import React from "react";
import { GiQuickSlash } from "react-icons/gi";

const BentoFeatures = () => {
  return (
    <section className="about_us_bento_features">
      <div className="about_us_bento_features__container">
        {/* Header */}
        <div className="about_us_bento_features__header">
          <h2 className="about_us_bento_features__badge">
            Why Teams Choose Us
          </h2>
          <h3 className="about_us_bento_features__title">
            Built for execution, clarity, and closure.
          </h3>
        </div>

        {/* Bento Grid */}
        <div className="about_us_bento_features__grid">
          {/* Card 1: Fewer clicks (large) */}
          <div className="about_us_bento_features__card about_us_bento_features__card--large">
            <div className="about_us_bento_features__icon about_us_bento_features__icon--light">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M14 4.1 12 6" />
                <path d="m5.1 8-2.9-.8" />
                <path d="m6 12-1.9 2" />
                <path d="M7.2 2.2 8 5.1" />
                <path d="M9.037 9.69a.498.498 0 0 1 .653-.653l11 4.5a.5.5 0 0 1-.074.949l-4.349 1.041a1 1 0 0 0-.74.739l-1.04 4.35a.5.5 0 0 1-.95.074z" />
              </svg>
            </div>
            <h4 className="about_us_bento_features__card_title">
              Fewer clicks to close work
            </h4>
            <p className="about_us_bento_features__card_text">
              Approvals, updates, reviews, files, and comments stay on one
              screen — so teams can move work forward without jumping between
              tabs.
            </p>
            <div className="about_us_bento_features__floating_ui">
              {/* 1. Review – star icon */}
              <div className="about_us_bento_features__chip">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M12 2l2.4 7.2h7.6l-6 4.8 2.4 7.2-6-4.8-6 4.8 2.4-7.2-6-4.8h7.6z" />
                </svg>
                <span>Review</span>
              </div>
              <div className="about_us_bento_features__chip_arrow">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M12 5v14m-4-4 4 4 4-4" />
                </svg>
              </div>
              {/* 2. Approve – checkmark inside circle */}
              <div className="about_us_bento_features__chip">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="m9 12 2 2 4-4" />
                </svg>
                <span>Approve</span>
              </div>

              {/* 3. Arrow Down (new chip in between) */}
              <div className="about_us_bento_features__chip_arrow">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M12 5v14m-4-4 4 4 4-4" />
                </svg>
              </div>

              {/* 4. Close – X icon */}
              <div className="about_us_bento_features__chip">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M18 6 6 18M6 6l12 12" />
                </svg>
                <span>Close</span>
              </div>
            </div>
          </div>

          {/* Card 2: Better visibility (dark) */}
          <div className="about_us_bento_features__card about_us_bento_features__card--dark">
            <div className="about_us_bento_features__icon about_us_bento_features__icon--dark">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            </div>
            <h4 className="about_us_bento_features__card_title about_us_bento_features__card_title--white">
              Better visibility
            </h4>
            <p className="about_us_bento_features__card_text about_us_bento_features__card_text--light">
              Know what’s pending, blocked, and due — at a glance.
            </p>
            <div className="about_us_bento_features__bar_chart">
              <div style={{ height: "40px" }}></div>
              <div style={{ height: "70px" }}></div>
              <div style={{ height: "45px" }}></div>
              <div style={{ height: "90px" }}></div>
              <div style={{ height: "65px" }}></div>
              <div style={{ height: "80px" }}></div>
            </div>
          </div>

          {/* Card 3: Structured collaboration */}
          <div className="about_us_bento_features__card">
            <div className="about_us_bento_features__icon about_us_bento_features__icon--blue">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <line x1="6" x2="6" y1="3" y2="15" />
                <circle cx="18" cy="6" r="3" />
                <circle cx="6" cy="18" r="3" />
                <path d="M18 9a9 9 0 0 1-9 9" />
              </svg>
            </div>
            <h4 className="about_us_bento_features__card_title">
              Task context
            </h4>
            <p className="about_us_bento_features__card_text">
              Notes, Files, Sub-Tasks, and Audit History stay with the task.
            </p>
          </div>

          {/* Card 4: Real operations */}
          <div className="about_us_bento_features__card about_us_bento_features__card--relative">
            <div className="about_us_bento_features__icon about_us_bento_features__icon--emerald">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
                <path d="m9 12 2 2 4-4" />
              </svg>
            </div>
            <h4 className="about_us_bento_features__card_title">
              Built for real approvals
            </h4>
            <p className="about_us_bento_features__card_text">
              Make-checker flows, access controls, audit trails, and client
              context are built in — because professional work needs
              accountability.
            </p>
            <div className="about_us_bento_features__glow"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BentoFeatures;
